import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import Core from 'core';

import Layout from '@/views/layout'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'

const AlarmList = () => import(/* webpackChunkName: "AlarmList" */ '../views/alarm/list')
const TargetList = () => import(/* webpackChunkName: "TargetList" */ '../views/target/list')
const TargetDetail = () => import(/* webpackChunkName: "TargetDetail" */ '../views/target/detail')
const AdminList = () => import(/* webpackChunkName: "AdminList" */ '../views/admin/list')
const NotificationManage = () => import(/* webpackChunkName: "NotificationManage" */ '../views/target/components/NotificationManage')

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/alarm/list'
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/home',
        component: Layout,
        children: [
            { path: '', component: Home },
        ]
    },
    {
        path: '/alarm',
        component: Layout,
        children: [
            { path: 'list', component: AlarmList },
        ]
    },
    {
        path: '/target',
        component: Layout,
        children: [
            { path: 'list', component: TargetList },
            { path: 'detail', component: TargetDetail },
        ]
    },
    {
        path: '/member',
        component: Layout,
        children: [
            { path: 'list', component: NotificationManage },
        ]
    },
    {
        path: '/admin',
        component: Layout,
        children: [
            { path: 'list', component: AdminList },
        ]
    }
]

const router = new VueRouter({
    routes,
})

NProgress.configure({
    easing: 'ease', // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3, // 初始化时的最小百分比
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

router.afterEach((to, from) => {
    NProgress.done()
    if (to.path !== '/login') {
        const token = Core.Data.getToken();
        if (!token) {
            Message({
                type: 'error',
                message: '请先登录'
            })
            router.replace({
                path: '/login',
            }).catch(err => {
                console.log(err)
            })
        }
    }
})

export default router
